import { EquationDojo } from "./EquationDojo";
export default EquationDojo;
